(function () {
  'use strict';

  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const announcementBar = document.querySelector('.announcement-bar-section');
  const SCROLL_THRESHOLD = 50;

  function update() {
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    header.style.top = `${Math.max(0, announcementHeight - window.scrollY)}px`;
    header.classList.toggle('scrolled', window.scrollY > SCROLL_THRESHOLD);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
